import React from 'react';

// Neutraal sectielabel voor zijbalkgroepen (bijv. "Reserveringen", "Facilitair").
// "Sectie" hier is een UI-indeling, niet hetzelfde als een billing-module uit
// core/entitlements.py -- een sectie kan meerdere modules bundelen.
const SectionLabel = ({ icon: Icon, name, description, compact = false }) => (
  <div className={compact ? 'px-3 pb-2 pt-1' : 'px-3 pb-3'}>
    <div className="flex items-center gap-2 text-slate-500">
      {Icon && <Icon className="h-4 w-4" />}
      <span className="text-xs font-semibold uppercase tracking-wide">{name}</span>
    </div>
    {description && !compact && <p className="mt-0.5 text-xs text-slate-400">{description}</p>}
  </div>
);

export default SectionLabel;
